var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m13.121 10.778 5.657-5.657M13.121 10.778l-.353-3.889M13.121 10.778l3.89.354M10.778 13.121l-5.657 5.657M10.778 13.121l.354 3.89M10.778 13.121l-3.889-.353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimise);
export default __webpack_public_path__ + "static/media/minimise.be1733470aea79ddf8570d1aef9cadae.svg";
export { ForwardRef as ReactComponent };